import { useContext, useEffect } from 'react'
import { ModalContext, useSessionTimer } from '@nv/contexts'
import CircleRightIcon from '@nv/images/design/circle-right-icon'
import ClockProgressIcon from '@nv/images/design/clock-progress-icon'
import RightArrowIcon from '@nv/images/design/right-arrow-icon'
import { useTranslation } from 'react-i18next'
import styles from './ExtendSession.module.scss'

export const ExtendSession = ({ endSession, doExtendSession, sessionTimeRemaining }: any) => {
  const { t } = useTranslation()
  const { setHeaderLabel, setBtns, onClose } = useContext(ModalContext)
  const { setSessionEnding } = useSessionTimer()

  useEffect(() => {
    setHeaderLabel(t('auth.admin.session.extend'))
    setBtns([
      {
        text: t('main.logout'),
        onClick: () => {
          endSession()
          onClose()
        },
        variant: 'secondary',
      },
      {
        text: t('auth.admin.session.extend'),
        onClick: () => {
          doExtendSession()
          onClose()
          setSessionEnding(false)
        },
      },
    ])
  }, [])

  return (
    <div className={styles['container']}>
      <div className={styles['icons']}>
        <ClockProgressIcon />
        <RightArrowIcon />
        <CircleRightIcon />
      </div>

      <div className={styles['session']}>
        {sessionTimeRemaining ? (
          <span className={styles['session__time']}>
            <span className={styles['session__label']}>{t('main.sessionTime')}</span>

            <div className={styles['session__time']}>
              <span className={styles['session__value']}>
                {sessionTimeRemaining.minutes} {t('countdown.time.short.mins')} {sessionTimeRemaining.seconds}{' '}
                {t('countdown.time.short.sec')}
              </span>
            </div>
          </span>
        ) : null}
      </div>

      <span className={styles['text']}>{t('auth.admin.session.askExtend')}</span>
    </div>
  )
}
